import { useEffect, useState } from "react";
import { Link } from "react-router";
import { Pages } from "../../../utils";
import { PRESS_LOGOS } from "./data";
import heroBackground from "../../../assets/home-page/hero.jpg";
import sealImage from "../../../assets/home-page/authorized-interior-designer-seal.png";

export const HeroSection = () => {
  const [pressReady, setPressReady] = useState(false);

  useEffect(() => {
    const raf = window.requestAnimationFrame(() => {
      setPressReady(true);
    });
    return () => {
      window.cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <section>
      <div className="hero">
        <div
          className="hero-bg"
          style={{
            backgroundImage: `url(${heroBackground})`,
          }}
        />

        <div className="hero-copy">
          <div className="eyebrow-hero fi">
            The Only Curated Interior Design Matching Service
          </div>
          <h1 className="hh fi">
            Your home deserves a designer who <em>truly gets you.</em>
          </h1>
          <p className="hero-p fi">
            Home Design Guild is the only curated matching service connecting
            discerning homeowners with vetted, HDG authorized interior designers
            — matched on personality, preferences, and project. Not a
            directory. A curated experience.
          </p>
          <div className="cta-row fi">
            <Link
              to={`${Pages.SIGNUP}?userType=Homeowner`}
              className="btn-w"
            >
              Find My Match →
            </Link>
            <Link to={Pages.SMART_GUILD_MATCHING} className="lnk-ghost">
              See How It Works →
            </Link>
          </div>
        </div>

        <div className="hero-img-panel">
          <img
            className="hero-seal-wrap"
            src={sealImage}
            alt="HDG Authorized Seal"
          />
        </div>
      </div>

      <div
        className={`press-bar fi ${pressReady ? "press-ready" : ""}`}
        style={{ borderTop: "1px solid rgba(0,0,0,.08)" }}
      >
        <div className="press-lbl">As Seen In</div>
        <div className="press-overflow">
          <div className="press-track">
            <div className="press-logos">
              {PRESS_LOGOS.map((logo) => (
                <div className="pl" key={`press-${logo}`}>
                  {logo}
                </div>
              ))}
            </div>
            <div className="press-logos" aria-hidden="true">
              {PRESS_LOGOS.map((logo) => (
                <div className="pl" key={`press-dup-${logo}`}>
                  {logo}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
